import { defineMeta } from '@/registry/types';

export const emptyStateMeta = defineMeta({
  name: 'EmptyState',
  level: 'organism',
  category: 'feedback',
  classification: 'custom',
  description: 'Zero-data / no-results placeholder with illustration, copy and optional action.',
  baseLibrary: 'custom',
  muiEquivalent: 'Box + Typography (composed)',
  a2uiEquivalent: 'EmptyState',
  importPath: '@/organisms/EmptyState',
  requiredProps: ['title'],
  optionalProps: ['description', 'icon', 'action', 'dense'],
  supportedStates: ['default', 'dense', 'with-action'],
  designTokens: ['colors', 'typography', 'spacing'],
  accessibility: ['Uses role="status" so the empty message is announced.'],
  usageExamples: [
    '<EmptyState title="No findings match these filters" description="Try widening the severity range." action={<Button>Clear filters</Button>} />',
  ],
  rules: [
    'Pass copy through `title` (h6, or subtitle1 when dense) and `description` (body1). Do not nest a second Typography for the same text.',
  ],
  antiPatterns: ['Do not use EmptyState to mask loading (use Skeleton).'],
  llmSafe: true,
  whenToUse: ['Empty tables/lists, no search results, first-run'],
  whenNotToUse: ['Loading states', 'Errors needing remediation (use Alert)'],
});

export default emptyStateMeta;
